import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  TimeScale,
  Filler,
} from "chart.js";
import "chartjs-adapter-date-fns";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  TimeScale,
  Filler
);

export default function PriceChart({ data, trend = true, unit = "month" }) {
  if (!data || data.length === 0) return null;

  // Tie the line + fill to the site's up/down palette.
  const lineColor = trend ? "#15633e" : "#9e1b1b";
  const fillRGB = trend ? "21, 99, 62" : "158, 27, 27";

  const chartData = {
    labels: data.map((entry) => entry.Date),
    datasets: [
      {
        label: "Close",
        data: data.map((entry) => entry.Close),
        borderColor: lineColor,
        borderWidth: 1.75,
        fill: true,
        backgroundColor: (ctx) => {
          const { chart } = ctx;
          const { ctx: c, chartArea } = chart;
          if (!chartArea) return `rgba(${fillRGB}, 0.08)`;
          const g = c.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
          g.addColorStop(0, `rgba(${fillRGB}, 0.16)`);
          g.addColorStop(1, `rgba(${fillRGB}, 0)`);
          return g;
        },
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHoverBackgroundColor: lineColor,
        pointHoverBorderColor: "#ffffff",
        tension: 0.18,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    // Quick, smooth update when the range changes.
    animation: { duration: 280, easing: "easeOutCubic" },
    animations: { x: { duration: 0 } },
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#121212",
        padding: 9,
        cornerRadius: 0,
        titleColor: "#b9b8b4",
        titleFont: { family: "Libre Franklin", size: 11 },
        bodyColor: "#fff",
        bodyFont: { family: "Libre Franklin", weight: "600" },
        displayColors: false,
        callbacks: {
          label: (item) => `$${Number(item.parsed.y).toFixed(2)}`,
        },
      },
    },
    scales: {
      x: {
        type: "time",
        time: { unit },
        grid: { display: false },
        border: { color: "#c8c6c0" },
        ticks: {
          color: "#8a8884",
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 7,
          font: { family: "Libre Franklin", size: 11 },
        },
      },
      y: {
        position: "right",
        grid: { color: "rgba(18,18,18,0.07)" },
        border: { display: false },
        ticks: {
          color: "#8a8884",
          font: { family: "Libre Franklin", size: 11 },
          callback: (value) => `$${value}`,
        },
      },
    },
  };

  return (
    <div className="chart-wrap">
      <Line data={chartData} options={options} />
    </div>
  );
}
